<div class="d-flex align-items-center tw-gap-x-2">
  <ng-container *ngIf="isSuccess; else failure">
    <mat-icon class="offer-snackbar--icon__success">check_circle_outline</mat-icon>
    <ng-template [ngIf]="type === 'publish'">{{ lenderName }} {{ offerName }} successfully published to portal</ng-template>
    <ng-template [ngIf]="type === 'remove_from_portal'">{{ lenderName }} {{ offerName }} successfully removed from portal</ng-template>
  </ng-container>
</div>

<ng-template #failure>
  <mat-icon class="offer-snackbar--icon__failure">error_outline</mat-icon>
  <ng-template [ngIf]="type === 'publish'">{{ lenderName }} {{ offerName }} failed to publish to portal</ng-template>
  <ng-template [ngIf]="type === 'remove_from_portal'">{{ lenderName }} {{ offerName }} failed to remove from portal</ng-template>
</ng-template>
